import React, { useState } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';

function ChangePasswordForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepetition, setNewPasswordRepetition] = useState('');

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            },
            '& .MuiInputBase-root': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '50%'
    };

    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };

    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newPassword === newPasswordRepetition) {
            setOpen(true);
            axios.get('/api/v1/Profile/ChangePasswordGET', {
                params: {
                    customerId: getAuthenticationToken().userID,
                    currentPassword: oldPassword,
                    goingToChangePassword: newPassword
                }
            }).then(response => {
                setMessageNotify({
                    severity: "success",
                    message: "تغییر کلمه عبور با موفقیت انجام شد",
                    open: true
                });
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "(در ورود کلمه عبور قدیمی دقت کنید)خطا در تغییر کلمه عبور",
                    open: true
                });
            }).finally(() => {
                setOpen(false);
            })
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "کلمه عبور جدید وارد شده با تکرار آن برابر نیست",
                open: true
            });

        }
    }

    const resetPassword = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.get('/api/v1/Profile/SetDefaultCustomerPassword', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then(response => {
            setMessageNotify({
                severity: "success",
                message: "تغییر کلمه عبور به کلمه عبور پیش فرض با موفقیت انجام شد",
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در تغییر کلمه عبور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        })
    }

    return (<>
        <form onSubmit={handleSubmit}>
            <div style={paperStyle} >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="oldPassword"
                            name="oldPassword"
                            label="کلمه عبور قدیمی"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={oldPassword}
                            onChange={e => setOldPassword(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField style={{ display: 'none' }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="newPassword"
                            name="newPassword"
                            label="کلمه عبور جدید"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="newPasswordRepetition"
                            name="newPasswordRepetition"
                            label="تکرار کلمه عبور جدید"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={newPasswordRepetition}
                            onChange={e => setNewPasswordRepetition(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Button
                            onClick={resetPassword}
                            id="resetPassword"
                            name="resetPassword"
                            fullWidth
                            variant="contained"
                            color="warning" >تغییر کلمه عبور به کلمه عبور پیش فرض</Button>
                    </Grid>
                    <div style={footerButtonContainerStyle}>
                        <div style={footerButtonStyle}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                variant="contained"
                                color="success"
                                fullWidth
                                style={formButtonElementStyle}>ثبت</Button>
                        </div>
                        <div style={footerButtonStyle}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                variant="contained"
                                color="success"
                                fullWidth
                                style={formButtonElementStyle}>انصراف</Button>
                        </div>
                    </div>
                </Grid>
            </div>
        </form>
        <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
    );
}

export default withRouter(ChangePasswordForm);